import {
  EVALUATE_CODE,
  GET_USER_PROBLEM_SUBMISSION_DETAILS,
  GET_USER_PROBLEM_SUBMISSION_RESULT_DETAILS,
} from "app/utils/constants/paths";

import jwtAuthAxios from "./auth/jwtAuth";

const compilerServices = {};

compilerServices.getAllSupportedProgrammingLanguages = async () => {
  const { data } = await jwtAuthAxios.get(
    "/services/semstarauthentication/api/user-problem-submissions/supported-languages"
  );
  return data;
};

compilerServices.getAllSupportedProgrammingLanguagesById = async (id) => {
  const { data } = await jwtAuthAxios.get(
    `/services/semstarauthentication/api/user-problem-submissions/supported-languages/${id}`
  );
  return data;
};

compilerServices.evaluateCode = async (code) => {
  const { data } = await jwtAuthAxios.post(EVALUATE_CODE, code);
  return data;
};

compilerServices.getUserProblemSubmissions = async (
  problemId,
  page = 0,
  size = 20
) => {
  const { data } = await jwtAuthAxios.get(
    `${GET_USER_PROBLEM_SUBMISSION_DETAILS}?sort=submittedOn,desc&problemsId.equals=${problemId}&page=${page}&size=${size}`
  );
  return data;
};

compilerServices.getSubmissionDetailsById = async (submissionId) => {
  const { data } = await jwtAuthAxios.get(
    `${GET_USER_PROBLEM_SUBMISSION_DETAILS}/${submissionId}`
  );
  return data;
};

compilerServices.getSubmissionResultById = async (submissionId) => {
  const { data } = await jwtAuthAxios.get(
    `${GET_USER_PROBLEM_SUBMISSION_RESULT_DETAILS}/${submissionId}`
  );
  return data;
};

export default compilerServices;
